import { gql } from '@apollo/client';

export const GET_ADDRESS_LOCATION_REVIEW_LISTING = gql`
  query GetAddressLocationReviewListing(
    $filters: AddressLocationReviewFiltersInput
    $pageRequest: PageRequestTypeInput
  ) {
    getAddressLocationReviewListing(filters: $filters, pageRequest: $pageRequest) {
      content {
        id
        requestId
        trackingNumber
        reportSource
        reporterAccount {
          id
          phone
          name
        }
        reviewerAccount {
          id
          phone
          name
        }
        address
        streetName
        latitude
        longitude
        reportedLatitude
        reportedLongitude
        createdAt
        status
      }
      page
      size
      totalElements
      totalPages
      hasNext
      hasPrevious
    }
  }
`;

export interface ReporterAccountType {
  id: string;
  phone: string | null;
  name: string;
}

export interface AddressLocationReviewType {
  id: string;
  requestId: string;
  trackingNumber: string;
  reportSource: 'DRIVER' | 'BACKEND';
  reporterAccount: ReporterAccountType | null;
  reviewerAccount: ReporterAccountType | null;
  address: string;
  streetName: string | null;
  latitude: string;
  longitude: string;
  reportedLatitude: string;
  reportedLongitude: string;
  createdAt: string;
  status: 'PENDING' | 'APPROVED' | 'REJECTED';
}

export interface AddressLocationReviewFiltersInput {
  address?: string;
  trackingNumber?: string;
  reporterAccountId?: number;
  reviewerAccountId?: number;
  reportSource?: 'DRIVER' | 'BACKEND';
  createdAtRange?: {
    start: string;
    end: string;
  };
  reviewStatus?: 'PENDING' | 'APPROVED' | 'REJECTED';
}

export interface PageRequestTypeInput {
  page: number;
  size: number;
  sortBy?: string;
  sortDirection?: 'ASC' | 'DESC';
}

export interface AddressLocationReviewPageResponseType {
  content: AddressLocationReviewType[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
  hasNext: boolean;
  hasPrevious: boolean;
}

export interface GetAddressLocationReviewListingResponse {
  getAddressLocationReviewListing: AddressLocationReviewPageResponseType;
}

